(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ac-map"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var GEOCODE_CACHE_KEY = 'ac-map:geocode:v1';

    var OSM_ATTR =
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

    var TILE_STYLES = {
      streets: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: OSM_ATTR,
        maxZoom: 19,
        subdomains: 'abc',
      },
      'streets-light': {
        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_3mtn_1_8f9a1d7259bb04f2b252fb2f',
        attribution:
          OSM_ATTR + ' &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 20,
        subdomains: 'abcd',
      },
      'streets-dark': {
        url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
        attribution:
          OSM_ATTR + ' &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 20,
        subdomains: 'abcd',
      },
      satellite: {
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        attribution:
          'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        maxZoom: 19,
        subdomains: '',
      },
    };

    var leafletPromise = null;

    function loadLeaflet(jsUrl, cssUrl) {
      if (window.L) return Promise.resolve(window.L);
      if (leafletPromise) return leafletPromise;

      leafletPromise = new Promise(function (resolve, reject) {
        if (cssUrl && !document.querySelector('link[data-ac-map-css]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = cssUrl;
          link.setAttribute('data-ac-map-css', '');
          document.head.appendChild(link);
        }

        var existing = document.querySelector('script[data-ac-map-js]');
        if (existing) {
          existing.addEventListener('load', function () {
            resolve(window.L);
          });
          existing.addEventListener('error', function () {
            reject(new Error('Failed to load Leaflet'));
          });
          return;
        }

        var script = document.createElement('script');
        script.src = jsUrl;
        script.async = true;
        script.setAttribute('data-ac-map-js', '');
        script.onload = function () {
          resolve(window.L);
        };
        script.onerror = function () {
          reject(new Error('Failed to load Leaflet'));
        };
        document.head.appendChild(script);
      });

      return leafletPromise;
    }

    function readCache() {
      try {
        var raw = window.localStorage.getItem(GEOCODE_CACHE_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    }

    function writeCache(cache) {
      try {
        window.localStorage.setItem(GEOCODE_CACHE_KEY, JSON.stringify(cache));
      } catch (e) {
        /* quota or disabled storage — ignore */
      }
    }

    function geocode(address) {
      var cache = readCache();
      if (cache[address]) return Promise.resolve(cache[address]);

      var url =
        'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' +
        encodeURIComponent(address);

      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : [];
        })
        .then(function (results) {
          if (!results || !results.length) return null;
          var coords = {
            lat: parseFloat(results[0].lat),
            lng: parseFloat(results[0].lon),
          };
          if (isNaN(coords.lat) || isNaN(coords.lng)) return null;
          cache[address] = coords;
          writeCache(cache);
          return coords;
        })
        .catch(function () {
          return null;
        });
    }

    function buildPinIcon(L) {
      var svg =
        '<svg class="ac-map__pin" viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M16 0C7.16 0 0 7.16 0 16c0 11.2 14.4 24.8 15.04 25.36a1.4 1.4 0 0 0 1.92 0C17.6 40.8 32 27.2 32 16 32 7.16 24.84 0 16 0z" fill="#c0392b"/>' +
        '<circle cx="16" cy="16" r="6" fill="#ffffff"/>' +
        '</svg>';
      return L.divIcon({
        className: 'ac-map__pin-wrap',
        html: svg,
        iconSize: [32, 42],
        iconAnchor: [16, 42],
        popupAnchor: [0, -36],
      });
    }

    function initMap(el, L) {
      if (el.hasAttribute('data-ac-map-ready')) return;
      el.setAttribute('data-ac-map-ready', '');

      var lat = parseFloat(el.getAttribute('data-lat'));
      var lng = parseFloat(el.getAttribute('data-lng'));
      var address = el.getAttribute('data-address') || '';
      var popup = el.getAttribute('data-popup') || address;
      var zoom = parseInt(el.getAttribute('data-zoom'), 10);
      if (isNaN(zoom)) zoom = 15;
      var scrollZoom = el.getAttribute('data-scroll-zoom') === 'true';
      var style = TILE_STYLES[el.getAttribute('data-style')] || TILE_STYLES.streets;

      function render(coords) {
        if (!coords || isNaN(coords.lat) || isNaN(coords.lng)) {
          el.setAttribute('data-ac-map-error', '');
          return;
        }

        var map = L.map(el, {
          center: [coords.lat, coords.lng],
          zoom: zoom,
          scrollWheelZoom: scrollZoom,
        });

        var tileOptions = {
          attribution: style.attribution,
          maxZoom: style.maxZoom,
        };
        if (style.subdomains) tileOptions.subdomains = style.subdomains;
        L.tileLayer(style.url, tileOptions).addTo(map);

        var marker = L.marker([coords.lat, coords.lng], {
          icon: buildPinIcon(L),
          title: address,
        }).addTo(map);

        if (popup) {
          var content = document.createElement('div');
          content.textContent = popup;
          marker.bindPopup(content);
        }
      }

      if (!isNaN(lat) && !isNaN(lng)) {
        render({ lat: lat, lng: lng });
      } else if (address) {
        geocode(address).then(render);
      } else {
        el.setAttribute('data-ac-map-error', '');
      }
    }

    function initAll() {
      var els = document.querySelectorAll(
        '.ac-map[data-ac-map]:not([data-ac-map-ready])'
      );
      if (!els.length) return;

      var first = els[0];
      var jsUrl = first.getAttribute('data-leaflet-js');
      var cssUrl = first.getAttribute('data-leaflet-css');

      loadLeaflet(jsUrl, cssUrl).then(function (L) {
        els.forEach(function (el) {
          initMap(el, L);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-back-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.collection-back-link[data-history-back]');
    if (!link) return;

    // Only hijack the click when there's a previous page to return to.
    // Otherwise let the anchor navigate to its fallback href.
    if (window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
